import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { OfferGoalsComponent } from "../offer-goals/offer-goals.component";
import { OfferChallengesComponent } from "../offer-challenges/offer-challenges.component";
import { OfferStore } from "../../../stores/offers/offer.store";
@Component({
    selector: "app-offer-goals-challenges",
    standalone: true,
    templateUrl: "./offer-goals-challenges.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatTabsModule, OfferGoalsComponent, OfferChallengesComponent],
    providers: [OfferStore],
})
export class OfferGoalsChallengesComponent {
    public offerStore: OfferStore = inject(OfferStore);
}
